import { Box } from '@chakra-ui/react';

const Card = ({ Content, children, ...rest }) => (
  <Box borderRadius="10px" {...rest}>
    {Content || children}
  </Box>
);

export default Card;
